module.exports = __webpack_public_path__ + "img/up-arrow.ffcd17c3.png";